import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu as MenuIcon, AccountCircle, Logout, Person } from "@mui/icons-material";

interface TopbarProps {
    handleDrawerToggle?: () => void; // Make it optional for user role restriction
}

const Topbar: React.FC<TopbarProps> = ({ handleDrawerToggle }) => {
    const navigate = useNavigate();

    // State for user menu
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleMenuToggle = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // Logout function
    const handleLogout = () => {
        // Clear authentication data
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        // Redirect to login page
        navigate("/login");

        // Close menu
        setIsMenuOpen(false);
    };

    const handleProfile = () => {
        navigate("/profile");
    };

    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    const userRole = userData?.role;

    const canToggleSidebar =
        userRole !== "user" || userData?.is_company_admin === "1";

    return (
        <header className="bg-white shadow-md w-full fixed top-0 left-0 z-50">
            <div className="flex items-center justify-between px-4 py-3">
                {/* Left Side: Sidebar Toggle Button (Hide if user role is "user") */}
                <div className="flex-1 flex">
                    {canToggleSidebar && (
                        <button onClick={handleDrawerToggle} className="text-gray-700 hover:text-black focus:outline-none">
                            <MenuIcon className="w-6 h-6" />
                        </button>
                    )}
                </div>

                {/* Center: Logo */}
                <h1 className="text-lg font-semibold text-gray-900 absolute left-1/2 transform -translate-x-1/2">
                    VDR
                </h1>

                {/* Right Side: User Menu */}
                <div className="flex-1 flex justify-end">
                    <button
                        onClick={handleMenuToggle}
                        className="bg-[#632DE9] text-white rounded-full p-2 focus:outline-none"
                    >
                        <AccountCircle className="w-6 h-6" />
                    </button>

                    {/* Dropdown Menu */}
                    {isMenuOpen && (
                        <div className="absolute right-0 mt-2 w-32 bg-white border border-gray-200 shadow-md rounded-md">
                            <button
                                onClick={handleProfile}
                                className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100"
                            >
                                <Person className="w-4 h-4 mr-2" />
                                Profile
                            </button>
                            <button
                                onClick={handleLogout}
                                className="flex items-center w-full px-4 py-2 text-gray-700 hover:bg-gray-100"
                            >
                                <Logout className="w-4 h-4 mr-2" />
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Topbar;
